<template>
	<div class="ctbBox" v-loading.fullscreen.lock="fullscreenLoading">
		<div class="ctbTabs">
			<div class="ctbTab">
				<div class="ctbTabItem" @click="tabFb(1)" :class="{ ctbTabItemActive: tabFlag == 1 }">课本类</div>
				<div class="ctbTabItem" @click="tabFb(3)" :class="{ ctbTabItemActive: tabFlag == 3 }">真题类</div>
				<div class="ctbTabItem" @click="tabFb(5)" :class="{ ctbTabItemActive: tabFlag == 5 }">试卷类</div>
				<div class="ctbTabItem" @click="tabFb(2)" :class="{ ctbTabItemActive: tabFlag == 2 }">每日一听类</div>
			</div>
			<div class="timBoxTitInfoBtn" @click="fullBtn">
				<img src="@/assets/img/qp.svg" alt="" />
				<span>全屏解析</span>
			</div>
		</div>
		<div class="ctbZjBox">
			<p>
				合计：
				<span>{{ total }}</span>
				套
			</p>
			<div class="ctbZjIcon" @click="qkBtn">
				<img src="@/assets/img/shanc.svg" alt="" class="icon" />
				点击清空
			</div>
		</div>
		<div class="ctbKsCont">
			<div class="kaoshiFixYs">
				<div class="kaoshiFixYsCont">
					{{ bsData.slice(bsIns, bsIns + 1)[0] + 'x' }}
				</div>
				<div class="kaoshiFixP">
					<img src="@/assets/img/x.png" @click="yusFn('-')" class="img1" alt="" />
					<p>语速调节</p>
					<img src="@/assets/img/s.svg" @click="yusFn('+')" class="img2" alt="" />
				</div>
			</div>
			<div class="kaoshiCont">
				<div class="kaoshiTm">
					<div class="kaoshiXtim" v-for="(fitem, findex) in tableData" :key="fitem.errorEditionId">
						<div class="kaoshiPNum">
							试题编号：{{ fitem.yydExaminationQuestion.number }}
							<img src="@/assets/img/shanc.svg" @click="delQbFn(fitem)" alt="" />
						</div>
						<h4>
							听材料回答以下{{ nums[fitem.yydExaminationQuestion.yydSmallQuestionList.length - 1] }}小题
							<!-- <div class="kaoshiWtBtn" @click="jtBtns(fitem.yydExaminationQuestion)">
                  <img src="@/assets/img/形状.png" alt="">
                  精听
                </div> -->
							<jting-button @btns="jtBtns(fitem.yydExaminationQuestion)" @qkFn="qkFn" :ref="'jting'" />
						</h4>
						<div class="kaoshiT" v-for="(item, index) in fitem.yydExaminationQuestion.yydSmallQuestionList" :key="index">
							<div class="kaoshiWt">
								<div class="kaoshiDa">
									<i>(</i>
									<span>{{ item.danVal }}</span>
									<i>)</i>
								</div>
								{{ index + 1 }}、{{ item.title }}
							</div>
							<div class="kaoshiXx">
								<p
									:class="{ active: item.danVal == zitem.number }"
									@click="item.danVal = zitem.number"
									v-for="(zitem, zindex) in item.yydSmallQuestionOptionList"
									:key="zindex"
								>
									{{ zitem.number }} 、{{ zitem.content }}
								</p>
							</div>
						</div>
					</div>
				</div>
				<fenye v-if="tableData.length" :total="total" ref="fybox" @dataFn="init" />
				<div class="zzAdminCont" v-if="!tableData.length">
					<el-empty description="暂无错题~"></el-empty>
				</div>
				<fullScreen :tmDec="tmDec" v-if="fullFlag" @gbFn="gbFns" ref="fullBoxs" />
			</div>
		</div>
	</div>
</template>

<script>
import fenye from '@/components/pubComponents/fenye';
import axios from 'axios';
import fullScreen from '@/page/user/fullScreen.vue';

export default {
	name: 'cuotiBen',
	data() {
		return {
			bsData: ['0.5', '0.75', '1', '1.25', '1.5', '1.75'],
			bsIns: 2,
			tabFlag: 1,
			fullscreenLoading: false,
			tableData: [],
			nums: ['一', '两', '三', '四', '五', '六', '七', '八', '九', '十', '十一', '十二'],
			total: 0,
			fullFlag: false,
			tmDec: '',
			fullscreen: ''
		};
	},
	components: {
		fenye,
		fullScreen
	},
	methods: {
		gbFns() {
			this.fullFlag = false;
			console.log(222222288888888888888);
		},
		qkFn() {
			console.log(this.$refs['jting'].length, 9999);
			if (this.$refs['jting'].length) {
				this.$refs['jting'].forEach((item) => {
					item.btnFlag = false;
					item.bfFlag = true;
				});
			} else {
				this.$refs['jting'].btnFlag = false;
				this.$refs['jting'].bfFlag = true;
			}
		},
		fullBtn() {
			if (this.tableData.length == 0) {
				this.$message({
					message: '暂无试题哦~',
					type: 'warning'
				});
				return;
			}
			let yydTextbookQuestions = this.tableData.map((item) => {
				return item.yydExaminationQuestion;
			});
			this.tmDec = JSON.stringify({
				name: this.tabFlag == 1 ? '课本类' : this.tabFlag == 3 ? '真题类' : this.tabFlag == 5 ? '试卷类' : '每日一听类',
				tabTxt: this.tabFlag == 1 ? '课本类' : this.tabFlag == 3 ? '真题类' : this.tabFlag == 5 ? '试卷类' : '每日一听类',
				yydTextbookQuestions
			});
			this.fullFlag = true;
			this.$nextTick(() => {
				this.$refs['fullBoxs'].onFullScreen();
			});
			// this.$router.push({
			//   path: './fullScreen',
			//   query: {
			//     tmDec: JSON.stringify({
			//       name: this.tabFlag==1?'课本类':this.tabFlag==3?'真题类':this.tabFlag==5?'试卷类':'每日一听类',
			//       tabTxt: this.tabFlag==1?'课本类':this.tabFlag==3?'真题类':this.tabFlag==5?'试卷类':'每日一听类',
			//       yydTextbookQuestions
			//     }),
			//   }
			// })
		},
		qkBtn() {
			if (this.tableData.length == 0) {
				this.$message({
					message: '暂无试题哦~',
					type: 'warning'
				});
				return;
			}
			this.$confirm(`是否清空错题本?`, '提示', {
				confirmButtonText: '确认',
				cancelButtonText: '取消',
				confirmButtonClass: 'delBtns',
				type: 'warning'
			})
				.then(() => {
					let set = this.$loading(this.$pre);
					this.$http.delete(`api/app/yydErrorEdition/clear/${this.tabFlag}`).then((res) => {
						set.close();
						if (res.code == 200) {
							this.$message({
								type: 'success',
								message: '清空成功'
							});
							this.init();
						}
					});
				})
				.catch(() => {});
		},
		delQbFn(item) {
			this.$confirm(`是否删除试题编号为${item.yydExaminationQuestion.number}?`, '提示', {
				confirmButtonText: '确认',
				cancelButtonText: '取消',
				confirmButtonClass: 'delBtns',
				type: 'warning'
			})
				.then(() => {
					let set = this.$loading(this.$pre);
					this.$http.delete(`api/app/yydErrorEdition/${item.errorEditionId}`).then((res) => {
						set.close();
						if (res.code == 200) {
							this.$message({
								type: 'success',
								message: '删除成功'
							});
							this.init();
						}
					});
				})
				.catch(() => {});
		},
		jtBtns(item) {
			console.log(item.recordingFileId, 7777);
			this.fullscreenLoading = true;
			this.$http
				.get('api/app/common/getUrl', {
					params: {
						fileId: item.recordingFileId,
						clientType: 1
					}
				})
				.then((res) => {
					this.fullscreenLoading = false;
					if (res.code == 200) {
						axios({
							method: 'get',
							url: res.msg,
							// timeout: 600000, // 请求超时时间，数据量多后台响应慢的情况可以调大点，没生效的话可能是vue.config.js里的配置影响了
							responseType: 'blob', // 返回类型为数据流
							headers: {
								clientType: 1,
								token: `${localStorage.getItem('token')}`
							}
						}).then((red) => {
							if (red && red.data) {
								const blob = new Blob([red.data], { type: 'audio/mpeg' });
								this.$audio.init(URL.createObjectURL(blob), (r) => {});
								this.$nextTick((r) => {
									this.$audio.play();
								});
							}
						});
					}
				});
		},
		daBtn(index, b, val) {
			// item = val
			this.$set(this.daJh[index].tms, b, val);
		},
		yusFn(type) {
			if (type == '-') {
				if (this.bsIns == 0) return;
				this.bsIns--;
			} else {
				if (this.bsIns == 5) return;
				this.bsIns++;
			}
			this.$audio.playbackRate(this.bsData.slice(this.bsIns, this.bsIns + 1)[0]);
		},
		tabFb(val) {
			this.tabFlag = val;
			this.init({
				pageNum: 1,
				pageSize: 10
			});
		},
		init(data) {
			let pre = '';
			if (data) {
				pre = {
					pageNum: data.pageNum,
					pageSize: this.$refs['fybox']?.pageSize || 10
				};
			} else {
				pre = {
					pageNum: this.$refs['fybox']?.pageNum,
					pageSize: this.$refs['fybox']?.pageSize
				};
			}
			this.fullscreenLoading = true;
			this.$http
				.get(`api/app/yydErrorEdition/list/${this.tabFlag}`, {
					params: {
						...pre
					}
				})
				.then((res) => {
					this.fullscreenLoading = false;
					if (res.code == 200) {
						res.rows.forEach((fitem) => {
							fitem.yydExaminationQuestion.yydSmallQuestionList.forEach((item) => {
								item.danVal = '';
							});
						});
						this.tableData = res.rows || [];
						this.total = res.total;
					}
				});
		}
	},
	mounted() {
		this.init({
			pageNum: 1,
			pageSize: 10
		});
	}
};
</script>
<style lang="scss" scoped>
.ctbBox {
	position: relative;
	.ctbTabs {
		padding: 0 21px 0 26px;
		display: flex;
		align-items: center;
		justify-content: space-between;
		.ctbTab {
			display: flex;
			align-items: center;
			font-size: 18px;

			color: #8a8a8a;
			height: 50px;
			.ctbTabItem {
				margin-right: 60px;
				cursor: pointer;
			}
			.ctbTabItemActive {
				color: #000;
				font-weight: bold;
			}
		}
	}
	.ctbZjBox {
		width: calc(100% - 20px);
		margin: 0 auto;
		height: 42px;
		background: #f3f4f7;
		border-radius: 2px;
		display: flex;
		align-items: center;
		padding-left: 14px;
		font-size: 14px;
		box-sizing: border-box;
		p {
			margin-right: 23px;
		}
		span {
			color: #1d7b3a;
		}
		.ctbZjIcon {
			color: #a0a0a2;
			display: flex;
			align-items: center;
			font-size: 14px;
			line-height: 1;
			cursor: pointer;
			img {
				width: 16px;
				height: 17px;
				margin-right: 3px;
			}
		}
	}
}
.timBoxTitInfoBtn {
	width: 90px;
	height: 30px;
	background: #ffac3e;
	display: flex;
	align-items: center;
	justify-content: center;
	margin-left: 10px;
	font-size: 14px;
	color: #ffffff;
	border-radius: 6px;
	cursor: pointer;
	img {
		width: 17px;
		height: 17px;
		margin-right: 3px;
	}
}
.ctbKsCont {
	padding: 0 14px 0 10px;
}
.kaoshiCont {
	padding: 10px 0 0 18px;
	color: #000000;
	h1 {
		font-size: 28px;
		padding-top: 38px;
		margin-bottom: 25px;
		font-weight: bold;
		text-align: center;
	}
	h2 {
		font-size: 18px;
		margin-bottom: 27px;
		text-align: center;
		padding-bottom: 34px;
		border-bottom: 1px solid #f8f8f8;
	}
	.kaoshiTm {
		h3 {
			font-size: 18px;
			font-weight: bold;
			margin: 40px 0 13px;
			text-indent: 2em;
		}
		> p {
			font-size: 16px;
			line-height: 2;
			text-indent: 2em;
			margin-bottom: 38px;
		}
		.kaoshiXtim {
			padding-bottom: 43px;
			border-bottom: 1px solid #f2f2f2;
			&:last-of-type {
				border-bottom: none;
			}
			.kaoshiPNum {
				display: flex;
				align-items: center;
				font-size: 14px;
				color: #3d3d3d;
				margin: 16px 0 15px;
				img {
					margin-left: 13px;
					width: 14px;
					height: 15px;
					cursor: pointer;
				}
			}
			h4 {
				font-size: 18px;
				margin: 15px 0 30px;
				display: flex;
				align-items: center;
			}
			.kaoshiT {
				margin-bottom: 40px;
				&:last-of-type {
					margin-bottom: 0;
				}
				.kaoshiXx {
					padding-left: 102px;

					p {
						margin-bottom: 32px;
						font-size: 18px;
						cursor: pointer;
						&:hover {
							color: #1d7b3a;
						}
						&:last-of-type {
							margin-bottom: 0;
						}
					}
					.active {
						color: #1d7b3a;
					}
				}
				.kaoshiWt {
					display: flex;
					font-weight: bold;
					margin-bottom: 36px;
					.kaoshiDa {
						width: 72px;
						margin-right: 30px;
						position: relative;
						display: flex;
						justify-content: space-between;
						margin-top: 2px;
						span {
							position: absolute;
							top: 50%;
							left: 50%;
							transform: translate(-50%, -50%);
						}
					}
				}
			}
		}
	}
}
.kaoshiWtBtn {
	margin-left: 19px;
	width: 63px;
	height: 26px;
	background: #1d7b3a;
	border-radius: 4px;
	color: #fff;
	font-size: 14px;
	display: flex;
	justify-content: center;
	align-items: center;
	font-weight: 400;
	cursor: pointer;
	img {
		width: 16px;
		height: 14px;
		margin-right: 6px;
	}
}
.kaoshiFixYs {
	position: sticky;
	float: right;
	margin-top: -40px;
	top: 15px;
	right: 7px;
	width: 108px;
	height: 98px;
	color: #fff;
	background: url('@/assets/img/ys.svg') 100% no-repeat;
	.kaoshiFixYsCont {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		margin-top: -4px;
	}
	.kaoshiFixP {
		position: absolute;
		bottom: 15px;
		width: 100%;
		display: flex;
		justify-content: center;
		font-size: 12px;
		align-items: center;
		p {
			margin: 0 6px;
		}
		img {
			width: 9px;
			height: 6px;
			cursor: pointer;
			margin-top: 1px;
		}
		.img1 {
			transform: rotate(90deg);
		}
		.img2 {
			transform: rotate(90deg);
		}
	}
}
</style>
